import React, { Suspense } from 'react';
import { Route } from 'react-router';
import { customSettingsOverview } from '../constants/constants';
import CustomSettinContainer from '../containers/CustomSettingsContainer/CustomSettingsContainer';
import PageLoader from '../components/PageLoader/PageLoader';

const CustomSettingOverviewPage = React.lazy(() => import('../pages/CustomSettingsPage/CustomSettingOverviewPage'));

const CustomSettingsRoutes = props => (
    <CustomSettinContainer {...props}>
        <Suspense fallback={<PageLoader />}>
            <Route path={customSettingsOverview} exact component={CustomSettingOverviewPage} />
        </Suspense>
    </CustomSettinContainer>
);

export default CustomSettingsRoutes;
